<div class="page-container" [class.loading]="isLoading">
    <div class="heading">
        <app-header
            title="{{ 'employees.organizationChart.people' | translate }}"
            [menuService]="employeeModuleMenuService"
        >
            <div class="buttons">
                <div class="ui toggle buttons">
                    <div class="ui icon basic disabled button"><mat-icon svgIcon="orgChart"></mat-icon></div>
                    <div class="ui icon basic button" (click)="goToAccordionView()">
                        <mat-icon svgIcon="list"></mat-icon>
                    </div>
                </div>

                <app-filter [groups]="filterGroups" (filter)="onFilter()"></app-filter>

                <ui-button class="context-menu" [matMenu]="settingstMatMenu">
                    <mat-icon svgIcon="settings"></mat-icon>
                </ui-button>

                <ui-button class="context-menu" [matMenu]="contextMatMenu">
                    <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                </ui-button>

                <ui-button type="primary" (click)="download()">{{
                    'employees.organizationChart.download' | translate
                }}</ui-button>
            </div>
        </app-header>
    </div>

    <app-org-chart-v2
        #orgChart
        *ngIf="nodes.length"
        [nodes]="nodes"
        [showPhotos]="togglePhotos"
        [showDepartmentColours]="toggleDepartments"
        [showNames]="toggleNames"
        [showPositions]="togglePositions"
        (onEmployeeClick)="gotToEmployee($event)"
    ></app-org-chart-v2>

    <mat-menu #contextMatMenu>
        <div class="padding-x-2 margin-top-1 margin-bottom-2">
            <a (click)="fullscreen()">
                <mat-icon class="margin-right-1" svgIcon="fullscreen"></mat-icon
                >{{ 'employees.organizationChart.fullscreen' | translate }}</a
            >
        </div>
        <div class="padding-x-2 margin-bottom-2">
            <a (click)="expandAll()">
                <mat-icon class="margin-right-1" svgIcon="expand"></mat-icon
                >{{ 'employees.organizationChart.expandAll' | translate }}</a
            >
        </div>
        <div class="padding-x-2 margin-bottom-2">
            <a (click)="collapseAll()">
                <mat-icon svgIcon="collapse"></mat-icon>{{ 'employees.organizationChart.collapseAll' | translate }}</a
            >
        </div>
        <div class="padding-x-2 margin-bottom-2">
            <a (click)="zoomIn()">
                <mat-icon class="margin-right-1" svgIcon="plus"></mat-icon
                >{{ 'employees.organizationChart.zoomIn' | translate }}</a
            >
        </div>
        <div class="padding-x-2 margin-bottom-1">
            <a (click)="zoomOut()">
                <mat-icon class="margin-right-1" svgIcon="subtract"></mat-icon
                >{{ 'employees.organizationChart.zoomOut' | translate }}</a
            >
        </div>
    </mat-menu>

    <mat-menu #settingstMatMenu>
        <div class="padding-x-2 margin-top-1 margin-bottom-2">
            <a (click)="toggleNames = !toggleNames; updateChart()">
                <mat-icon class="margin-right-1" *ngIf="toggleNames" svgIcon="check"></mat-icon>
                <mat-icon class="margin-right-1" *ngIf="!toggleNames" svgIcon="subtract"></mat-icon>
                <span>{{ 'employees.organizationChart.employeeNames' | translate }}</span>
            </a>
        </div>
        <div class="padding-x-2 margin-bottom-2">
            <a (click)="togglePhotos = !togglePhotos; updateChart()">
                <mat-icon class="margin-right-1" *ngIf="togglePhotos" svgIcon="check"></mat-icon>
                <mat-icon class="margin-right-1" *ngIf="!togglePhotos" svgIcon="subtract"></mat-icon>
                <span>{{ 'employees.organizationChart.employeePhotos' | translate }}</span>
            </a>
        </div>
        <div class="padding-x-2 margin-bottom-2">
            <a (click)="toggleDepartments = !toggleDepartments; updateChart()">
                <mat-icon class="margin-right-1" *ngIf="toggleDepartments" svgIcon="check"></mat-icon>
                <mat-icon class="margin-right-1" *ngIf="!toggleDepartments" svgIcon="subtract"></mat-icon>
                <span>{{ 'employees.organizationChart.departmentColor' | translate }}</span>
            </a>
        </div>
        <div class="padding-x-2 margin-bottom-1">
            <a (click)="togglePositions = !togglePositions; updateChart()">
                <mat-icon class="margin-right-1" *ngIf="togglePositions" svgIcon="check"></mat-icon>
                <mat-icon class="margin-right-1" *ngIf="!togglePositions" svgIcon="subtract"></mat-icon>
                <span>{{ 'employees.organizationChart.positions' | translate }}</span>
            </a>
        </div>
    </mat-menu>
</div>
